import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import DataTable from 'react-data-table-component';
import { SearchIcon } from '@primer/octicons-react';
import { axiosAuth_ASSET_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
//import { UserContext } from "../UserContext";
import { translateAPIError } from '../utils/apiUtils';
//import { hasAnyPerm } from '../utils/uiUtils';
import classes from './AdminPages.module.css';
import { formatDate } from '../utils/timeUtils';
import DeleteConfirmDialog from './DeleteConfirmDialog';


const AssetImportAdminListView = (props) => {

  const { t } = useTranslation(['common', 'custom']);

  const [errMsg,                  setErrMsg]                  = useState('');
  const [notFoundMsg,             setNotFoundMsg]             = useState('');

  const [searchTerms,             setSearchTerms]             = useState();


  // ----- Data Table stuff -----

  const [objList,   setObjList]   = useState([]);
  const [,          setLoading]   = useState(false);
  const [totalRows, setTotalRows] = useState();
  const [perPage,   setPerPage]   = useState(25);
  const [currPage,  setCurrPage]  = useState(1);
  const [sortCol,   setSortCol]   = useState(null);
  const [sortDir,   setSortDir]   = useState(null);

  const customStyles = {
    rows: {
      style: {
        minHeight: '25px', // override the row height
        fontSize: '11px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',
      },
    },
  };

  const columns = [
    {
      name: t("I18N_ID"),
      selector: row => row.id,
      sortable: true,
      sortField: 'id',
      cell: row => (
        <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleObjDetails(row)}>{row.id}</span>
      ),
      grow: 1
    },
    {
      name: t("I18N_Comments"),
      selector: row => row.comments,
      grow: 2
    },
    {
      name: t("I18N_Asset_code"),
      selector: row => row.assetCode,
      sortable: true,
      sortField: 'assetCode',
      grow: 2
    },
    {
      name: t("I18N_Import_mode"),
      selector: row => t("I18N_" + row.importMode),
      grow: 1
    },
    {
      name: t("I18N_Import_req_time"),
      selector: row => formatDate(row.requestTime),
      sortable: true,
      sortField: 'requestTime',
      grow: 2
    },
    {
      name: t("I18N_Import_requester"),
      selector: row => row.requester,
      sortable: true,
      sortField: 'requester',
      grow: 1
    },
    {
      name: t("I18N_Status"),
      selector: row => t("I18N_" + row.status),
      sortable: true,
      sortField: 'status',
      grow: 1
    },
    {
      name: t("I18N_Status_update_time"),
      selector: row => formatDate(row.statusTime),
      grow: 2
    },
/*
    {
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: row => (
        hasAnyPerm(user, ["OrgAdminGeneralDeleteAccess"], true) ?
          <OverlayTrigger overlay={<Tooltip id="tooltip-delete-dp" style={{fontSize:'11px'}}>{t("I18N_TIP_New_asset_import")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}}
                  onClick={() => handleObjDelete(row)}><BiTrash size={16} />
            </span>
          </OverlayTrigger>
       : null
      )
    }
*/
  ];


  const handlePageChange = currPage => {
    setCurrPage(currPage);
    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    currPage});

    fetchObjs(searchTerms, sortCol, sortDir, perPage, currPage);
  };


  const handlePerRowsChange = async (newPerPage) => {

    setPerPage(newPerPage);
    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     newPerPage,
                          currPage:    1});

    fetchObjs(searchTerms, sortCol, sortDir, newPerPage, 1);
  };


  const handleSort = (column, sortDir) => {

    // instead of setTimeout this is where you would handle your API call.
    setSortCol (column.sortField);
    setSortDir (sortDir);

    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     column.sortField,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    1});

    fetchObjs(searchTerms, column.sortField, sortDir, perPage, 1);
  };

  const paginationComponentOptions={
          rowsPerPageText: t("I18N_Rows_per_page"),
          rangeSeparatorText: t("I18N_Pagination_page_of_total"),
          noRowsPerPage: false,
          selectAllRowsItem: false,
          selectAllRowsItemText: 'All'
        };

  // ----- END - Data Table stuff -----


  // ----- Asset Import Dialog stuff -----

  const [showAssetImportDialog,    setShowAssetImportDialog]   = useState(false);
  const [importMode,               setImportMode]              = useState('IMPORT_SINGLE');
  const [assetImportInfo,          setAssetImportInfo]         = useState({
                                                                   comments: '',
                                                                   assetCode: ''
                                                                 });
  const [assetList,                setAssetList]                = useState([]);
  const [errMsg_AssetImportDialog, setErrMsg_AssetImportDialog] = useState('');


  const handleAssetSearch = (e) => {
    e.preventDefault();

    if (assetImportInfo.assetCode === '') {
      setErrMsg_AssetImportDialog(t('I18N_ERR_Need_search_term'));
      return;
    }

    // Replace any space and comma with '%', and wrap the with '%'

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.get("assets?searchTerms=" + assetImportInfo.assetCode + "&limit=100&offset=0");

        resolve(res.data);

        if (res.status === 200) {
          if (res.data.data.length > 0) {
            setAssetList(res.data.data);
            setErrMsg_AssetImportDialog('');
          } else {
            setAssetList([]);
            setErrMsg_AssetImportDialog(t("I18N_No_search_result"));
          }
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_AssetImportDialog(t(translateAPIError(error)));
        }
      }
    });

  }


  function handleAssetImportDialogCancel() {
    setErrMsg_AssetImportDialog('');
    setShowAssetImportDialog(false);
  }

  function handleAssetImportDialogSubmit() {
    setErrMsg_AssetImportDialog('');

    if (importMode === 'IMPORT_ALL') {
      // Show confirmation dialog
      setShowImportConfirmDialog(true);
    } else {
      handleImportConfirmSubmit();
    }
  }


  function handleAssetSelect(asset) {
    setAssetList([]);
    setAssetImportInfo({ ...assetImportInfo, assetCode: asset.code })
  }

  const onAssetSearchInputChange = (e) => {
    setAssetImportInfo({ ...assetImportInfo, [e.target.name]: e.target.value })
  }

  function renderAsset(asset, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width: "40%"}}>{asset.code}</td>
        <td style={{width: "40%"}}>{asset.description}</td>
        <td style={{width: "20%"}}>
          <Button size="tiny" variant="outline-secondary" style={{ float: 'left' }} onClick={() => handleAssetSelect(asset)}>
            {t("I18N_Select")}
          </Button>
       </td>
      </tr>
    )
  }


  // Initialize state
  useEffect(() => {

    setSearchTerms(props.pageState.searchTerms);
    setSortCol(props.pageState.sortCol);
    setSortDir(props.pageState.sortDir);
    setPerPage(props.pageState.perPage);
    setCurrPage(props.pageState.currPage);

    fetchObjs(props.pageState.searchTerms, props.pageState.sortCol, props.pageState.sortDir, props.pageState.perPage, props.pageState.currPage);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  const onInputChange = (e) => {
    setSearchTerms(e.target.value);
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    setCurrPage(1); // Reset to page 1 for a fresh search
    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    1});

    fetchObjs(searchTerms, sortCol, sortDir, perPage, 1);
  }


  const fetchObjs = async (searchTerms, sortCol, sortDir, perPage, currPage) => {

    try {
      setLoading(true);

      const res = await axiosAuth_ASSET_MGMT_API.get("asset-import-reqs?searchTerms=" +
                                                     ((searchTerms && (searchTerms !== null)) ? encodeURIComponent(searchTerms) : '') +
                                                     ((sortCol     && (sortCol     !== null)) ? ("&sortColumn=" + sortCol + "&sortDirection=" + sortDir) : '')  +
                                                     ((perPage     && (perPage     !== null)) ? ("&limit="      + perPage)                               : '')  +
                                                     ((currPage    && (currPage    !== null)) ? ("&offset="     + (currPage - 1) * perPage)              : ''));

      if (res.data.data.length === 0) {
        setNotFoundMsg("I18N_No_search_result");
      } else {
        setNotFoundMsg('');
      }

      setObjList(res.data.data);

      setTotalRows(res.data.total);
      setLoading(false);
      setErrMsg('');
    } catch (error) {
      if (!error.message || (error.message !== 'IGNORE')) {
        setErrMsg(t(translateAPIError(error)));
      }
    }
  }


  function handleObjDetails(assetImport) {
    props.onUIMode('DETAILS', assetImport)
  }

  const handleSingleAssetImport = (e) => {
    e.preventDefault();
    setImportMode('IMPORT_SINGLE');

    // Clear form fields
    setAssetImportInfo({
                          comments: '',
                          assetCode: ''
                       });

    setShowAssetImportDialog(true);
  }

  const handleAllAssetImport = (e) => {
    e.preventDefault();
    setImportMode('IMPORT_ALL');

    // Clear form fields
    setAssetImportInfo({
                          comments: '',
                          assetCode: ''
                       });

    setShowAssetImportDialog(true);
  }


  // Import Confirm Dialog stuff

  const [showImportConfirmDialog,       setShowImportConfirmDialog]       = useState(false);
  const [errMsgImportConfirm,           ]                                 = useState('');

  // --- New Request ---

  function handleImportConfirmCancel() {
    setShowImportConfirmDialog(false);
  }

  function handleImportConfirmSubmit() {

    // Reserved for future needs for any parameters.
    let reqBody = assetImportInfo;

    if (assetImportInfo.assetCode && (assetImportInfo.comments.length > 200)) {
      setErrMsg_AssetImportDialog(t('I18N_ERR_Max_len_remarks') + 200);
      return;
    }

    if (importMode === 'IMPORT_SINGLE') {

      if ((assetImportInfo.assetCode === null) || (assetImportInfo.assetCode.trim().length === 0)) {
        setErrMsg_AssetImportDialog(t('I18N_Need_asset_code'));
        return;
      } else if (assetImportInfo.assetCode.trim().length > 50) {
        setErrMsg_AssetImportDialog(t('I18N_ERR_Max_len_asset_code') + 50);
        return;
      } else {
        reqBody.assetCode = reqBody.assetCode.trim();
      }
    }

    reqBody.importMode = importMode;

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_ASSET_MGMT_API.post("asset-import-reqs", reqBody);

        resolve(res.data);

        if (res.status === 201) {
          setErrMsg_AssetImportDialog('');
          setShowImportConfirmDialog(false);
          setShowAssetImportDialog(false);

          setAssetImportInfo({});

          // Update list
          fetchObjs(searchTerms, sortCol, sortDir, perPage, 1);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setShowImportConfirmDialog(false);
        setErrMsg_AssetImportDialog(t(translateAPIError(error)));
      }
    });
  }


  return (
    <>
      <Card className='aaa' style={{border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)', padding:'20px 40px 20px 40px', maxWidth:'2500px', height:'850px', width:'100%'}}>
        <div style={{ display: 'flex' }}>
          <span className={classes.admin_pages__page_title}>
            {t("I18N_Asset_Import_Mgmt")}
          </span>
          <span style={{marginLeft:'auto', marginTop:'7px', color:'rgba(200,0,0)', fontSize:'12px'}}>
            {errMsg}
          </span>
          <div style={{ display: 'flex', marginLeft: '30px', marginRight: '0px', width: '450px', minWidth: '450px' }}>

            <Button size="tiny" variant="outline-secondary" className="mb-3"
              style={{marginTop: '6px'}}
              onClick={handleSingleAssetImport}>
              {t("I18N_Import_single_asset")}
            </Button>

            <Button size="tiny" variant="outline-secondary" className="mb-3"
              style={{marginLeft: '10px', marginTop: '6px'}}
              onClick={handleAllAssetImport}>
              {t("I18N_Import_all_assets")}
            </Button>

            <span style={{ marginLeft: '20px', marginRight: '0px', width: '220px' }}>
              <Form onSubmit={handleSearchSubmit}>
                <Form.Group as={Row} >
                  <Col sm="9" style={{ marginRight: '5px' }}>
                    <Form.Control style={{ fontSize: '12px' }} type="text" name="searchTerms" value={searchTerms} onChange={(e) => onInputChange(e)} placeholder={t("I18N_Search_terms")} />
                  </Col>
                  <Col sm="2" style={{ padding: '5px' }}>
                    <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip-search" style={{fontSize:'11px'}}>{t("I18N_Search")}</Tooltip>}>
                      <span onClick={handleSearchSubmit} style={{ cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                        <SearchIcon size={18} />
                      </span>
                    </OverlayTrigger>
                  </Col>
                </Form.Group>
              </Form>
            </span>
          </div>
        </div>

        { (notFoundMsg && notFoundMsg !== '') ?
          <span className={classes.admin_pages__field_value} style={{marginTop:'20px'}}>
            {t(notFoundMsg)}
          </span>
        :
          <div style={{ overflowY:'auto', fontSize:'11px', marginTop:'10px' }}>

            { objList && objList.length > 0 ?
              <DataTable
                columns={columns}
                data={objList}
                customStyles={customStyles}
                fixedHeader
                fixedHeaderScrollHeight={'700px'}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationDefaultPage={currPage}
                paginationPerPage={perPage}
                paginationRowsPerPageOptions={[25,50,100]}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                onSort={handleSort}
                sortServer
                highlightOnHover
                paginationComponentOptions={paginationComponentOptions}
                noDataComponent={t("I18N_No_search_result")}
              />
            : null
            }

          </div>
        }

        <Modal show={showAssetImportDialog} onHide={handleAssetImportDialogCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              { importMode === 'IMPORT_SINGLE' ?
                <span>
                  {t("I18N_Import_Single_Asset")}
                </span>
              :
                <span>
                  {t("I18N_Import_All_Assets")}
                </span>
              }

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Comments")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="comments"
                      value={assetImportInfo && assetImportInfo.comments ? assetImportInfo.comments : ''}
                      onChange={(e) => onAssetSearchInputChange(e)} />
                  </Col>
                </Row>

                { importMode === 'IMPORT_SINGLE' ?
                  <>
                    <Row className={classes.admin_pages__field_label}>
                      <Col>{t("I18N_Asset_code")}: *</Col>
                    </Row>
                    <Row className={classes.admin_pages__field_value}>
                      <Col>
                        <Form onSubmit={handleAssetSearch}>
                          <Form.Control style={{ fontSize: '12px', height:'22px' }} type="text" name="assetCode" value={assetImportInfo.assetCode}
                                        onChange={(e) => onAssetSearchInputChange(e)} />
                        </Form>
                      </Col>
                      <Col>
                        <span onClick={handleAssetSearch} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                          <SearchIcon size={14} />
                        </span>
                      </Col>
                    </Row>

                    { assetList && assetList.length > 0 ?
                      <>
                        <hr className="solid" style={{ margin: '10px 0 10px 0' }}></hr>

                        <div style={{overflowY:'scroll', fontSize:'11px', marginTop:'10px', maxHeight:'600px'}}>
                          <Table hover responsive size="sm">
                            <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                              <tr>
                                <th style={{fontWeight:'400'}}>{t("I18N_Asset_code")}</th>
                                <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {(assetList && assetList.length > 0) ? assetList.map(renderAsset) : null}
                            </tbody>
                          </Table>
                        </div>
                      </>
                    : null
                    }

                  </>
                : null
                }

                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_AssetImportDialog}
                  </span>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleAssetImportDialogCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '10px' }}
                      onClick={handleAssetImportDialogSubmit}>
                      {t("I18N_Import")}
                    </Button>
                  </div>
                </Row>

            </div>
          </Modal.Body>
        </Modal>

        <DeleteConfirmDialog
          title={t("I18N_Request_asset_import_confirm")}
          show={showImportConfirmDialog}
          backgroundColor='#DADADA'
          targetName=''
          errMsgDeleteConfirm={errMsgImportConfirm}
          onCancel={handleImportConfirmCancel}
          onSubmit={handleImportConfirmSubmit}
        />

      </Card>
    </>
  );
}


export default AssetImportAdminListView;
